'use client';

import React, { useMemo, type ComponentProps, type FC } from 'react';
import { CartItemGroup as BaseCartItemGroup } from '@kidslabs/module-quote';
import { AfterCartItemGroupComponent as AfterCartItemGroupComponentNova } from '../after-cart-item-group-component';
import { CartItem } from '../cart-item';

/**
 * CartItemGroup - Cart item group wrapper for Nova theme
 *
 * Injects:
 * - AfterCartItemGroupComponent: Shows gifts of product in cart
 * - CartItemComponent: Custom CartItem with additional information
 *
 * Note: We need to cast AfterCartItemGroupComponent because:
 * - The module-quote CartItemGroupProps.AfterCartItemGroupComponent expects full CartItemReference
 * - This is safe because BaseCartItemGroup passes the full CartItemReference from props
 *
 * Matches mobile module-theme-hermes implementation:
 * @see mobile-ecommerce/applications/module-theme-hermes/src/modules/quote/components/cart-item-group/cart-item-group.tsx
 */
export const CartItemGroup: FC<ComponentProps<typeof BaseCartItemGroup>> = props => {
    const renderAfterCartItemGroupComponentNova = useMemo(() => AfterCartItemGroupComponentNova, []) as ComponentProps<
        typeof BaseCartItemGroup
    >['AfterCartItemGroupComponent'];

    return (
        <BaseCartItemGroup
            AfterCartItemGroupComponent={renderAfterCartItemGroupComponentNova}
            CartItemComponent={CartItem}
            {...props}
        />
    );
};

export default CartItemGroup;
